import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';

export const getAllAnnualIncome = async () => {
  const res = await axios.get(`${endpoint.getAnnualIncome}/all`);
  return res.data;
};

export const getAllOvertimeHours = async () => {
  const res = await axios.get(`${endpoint.getOvertimeHours}/all`);
  return res.data;
};

export const getAllRemoteWork = async () => {
  const res = await axios.get(`${endpoint.getRemoteWork}/all`);
  return res.data;
};

export const getAllSideJob = async () => {
  const res = await axios.get(`${endpoint.getSideJob}/all`);
  return res.data;
};

export const getAllWorkCnd = async () => {
  const res = await axios.get(`${endpoint.getWorkCnd}/all`);
  return res.data;
};

export const getAllJobDsc = async () => {
  const res = await axios.get(`${endpoint.getJobDsc}/all`);
  return res.data;
};

export const getDialogOccupation = async () => {
  const res = await axios.get(endpoint.getDialogOccupation);
  return res.data;
};

export const getOccupationById = async (id: string) => {
  const res = await axios.get(`${endpoint.getOccupation3}/${id}`);
  return res.data;
};

export const getAllOccupation3 = async () => {
  const res = await axios.get(`${endpoint.getOccupation3}/all`);
  return res.data;
};

export const getDialogPref = async () => {
  const res = await axios.get(endpoint.getDialogPref);
  return res.data;
};

export const getDialogIndustry = async () => {
  const res = await axios.get(endpoint.getDialogIndustry);
  return res.data;
};

export const getAllIndustry = async () => {
  const res = await axios.get(`${endpoint.getIndustry}/all`);
  return res.data;
};

export const getAllPref = async () => {
  const res = await axios.get(`${endpoint.getPref}/all`);
  return res.data;
};

export const getAllCity = async () => {
  const res = await axios.get(`${endpoint.getCity}/all`);
  return res.data;
};

export const getAllWalkBus = async () => {
  const res = await axios.get(`${endpoint.getWalkBus}/all`);
  return res.data;
};

export const getAllStation = async () => {
  const res = await axios.get(`${endpoint.getStation}/all`);
  return res.data;
};

export const getAllEntrances = async () => {
  const res = await axios.get(`${endpoint.getEntrance}/all`);
  return res.data;
};

export const getAllGrad = async () => {
  const res = await axios.get(`${endpoint.getGrad}/all`);
  return res.data;
};

export const getAllLstschl = async () => {
  const res = await axios.get(`${endpoint.getLstschl}/all`);
  return res.data;
};

export const getAllOtrlang = async () => {
  const res = await axios.get(`${endpoint.getOtrlang}/all`);
  return res.data;
};

export const getAllLanguageLevel = async () => {
  const res = await axios.get(`${endpoint.getLanguageLevel}/all`);
  return res.data;
};

export const getAllLicenses = async () => {
  const res = await axios.get(`${endpoint.getLicenses}/all`);
  return res.data;
};

export const getAllChangeaddr = async () => {
  const res = await axios.get(`${endpoint.getChangeaddr}/all`);
  return res.data;
};

export const getAllLicensesByName = async (name: string) => {
  const res = await axios.post(`${endpoint.getLicenses}/search_by_name`, {
    value: name,
  });
  return res.data;
};
export const getLicensesNameById = async (id: string) => {
  const res = await axios.get(`${endpoint.getLicenses}/get_licensename_name/${id}`);
  return res.data;
};

export const getAllRailwayStationByName = async (name: string) => {
  const res = await axios.post(`${endpoint.getRailwayStation}/get_search`, {
    value: name,
  });
  return res.data;
};
export const getRailwayStationNameById = async (stationId: string) => {
  const res = await axios.get(`${endpoint.getRailwayStation}/get_name/${stationId}`);
  return res.data;
};

export const getAllSchlByName = async (name: string) => {
  const res = await axios.post(`${endpoint.getSchl}/search_by_name`, {
    value: name,
  });
  return res.data;
};
export const getSchlNameById = async (schlId: string) => {
  const res = await axios.get(`${endpoint.getSchl}/get_schlid_name/${schlId}`);
  return res.data;
};

export const getAllSchl = async () => {
  const res = await axios.get(`${endpoint.getSchl}/all`);
  return res.data;
};

export const getAllSex = async () => {
  const res = await axios.get(`${endpoint.getSex}/all`);
  return res.data;
};

export const getAllInhabitType = async () => {
  const res = await axios.get(`${endpoint.getInhabitType}/all`);
  return res.data;
};

export const getAllWkStatus = async () => {
  const res = await axios.get(`${endpoint.getWorkStatus}/all`);
  return res.data;
};

export const getAllAllowance = async () => {
  const res = await axios.get(`${endpoint.getAllowance}/all`);
  return res.data;
};

export const getAllPeopleManagement = async () => {
  const res = await axios.get(`${endpoint.getPeopleManagement}/all`);
  return res.data;
};

export const getAllPeopleManagementYear = async () => {
  const res = await axios.get(`${endpoint.getPeopleManagementYear}/all`);
  return res.data;
};

export const getAllEmpType = async () => {
  const res = await axios.get(`${endpoint.getEmpType}/all`);
  return res.data;
};

export const getAllListed = async () => {
  const res = await axios.get(`${endpoint.getListed}/all`);
  return res.data;
};

export const getAllYearCategory = async () => {
  const res = await axios.get(`${endpoint.getYearCategory}/all`);
  return res.data;
};
export const getAllApply = async () => {
  const res = await axios.get(`${endpoint.getApply}/all`);
  return res.data;
};

export const getAllFailure = async () => {
  const res = await axios.get(`${endpoint.getFailure}/all`);
  return res.data;
};

export const getAllEmployee = async () => {
  const res = await axios.get(`${endpoint.getEmployee}/all`);
  return res.data;
};

export const getAllJobchangetime = async () => {
  const res = await axios.get(`${endpoint.getJobchangetime}/all`);
  return res.data;
};

export const getAllSelectionPhase = async () => {
  const res = await axios.get(`${endpoint.getSelectionPhase}/all`);
  return res.data;
};

export const getAllAspiration = async () => {
  const res = await axios.get(`${endpoint.getAspiration}/all`);
  return res.data;
};

export const getAllCourse = async () => {
  const res = await axios.get(`${endpoint.getCourse}/all`);
  return res.data;
};

export const getAllPurpoSeagent = async () => {
  const res = await axios.get(`${endpoint.getPurpoSeagent}/all`);
  return res.data;
};